// extracted by mini-css-extract-plugin
export default {"Action":"style_Action__k2d40","Action__caption":"style_Action__caption__0MZAJ"};